export default __webpack_public_path__ + "static/media/comments_closed_icon.52f28c80.svg";